const FancyArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      width="14"
      height="24"
      viewBox="0 0 14 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.55957 23C0.55957 23 3.25067 12 13.9996 12C3.2352 12 0.55957 1 0.55957 1"
        stroke="#3A3D50"
        strokeWidth="0.928499"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default FancyArrow;
